interface ScoreSession {
  gameId: string;
  startTime: number;
  maxScorePerSecond: number;
}

export class ScoreValidator {
  private session: ScoreSession | null = null;

  startSession(gameId: string, maxScorePerSecond = 5000): void {
    this.session = {
      gameId,
      startTime: Date.now(),
      maxScorePerSecond,
    };
  }

  validate(score: number, sessionMs?: number): { valid: boolean; reason?: string } {
    if (score < 0) {
      return { valid: false, reason: 'Skor negatif olamaz.' };
    }

    if (!this.session) {
      return { valid: true }; // Oturum yoksa temel kontrolden geç
    }

    const elapsedSeconds = (sessionMs ?? (Date.now() - this.session.startTime)) / 1000;

    // Minimum mantıklı süre kontrolü
    if (elapsedSeconds < 1 && score > 5000) {
      return { valid: false, reason: 'Oyun süresi skora kıyasla çok kısa.' };
    }

    const theoreticalMax = Math.max(10, elapsedSeconds * this.session.maxScorePerSecond);
    if (score > theoreticalMax) {
      return { valid: false, reason: 'Skor teorik maksimum sınırı aştı.' };
    }

    return { valid: true };
  }

  endSession(): void {
    this.session = null;
  }
}
